import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-zinc-500 font-data text-xs tracking-[0.25em] uppercase">
        loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
